<template>
  <AhaPage id="main-page">
    <AhaHeader>
      <MainHeader is-moderating />
    </AhaHeader>

    <AhaContent v-if="isLoadingPresentation">
      <div class="h-full flex items-center justify-center">
        <div>
          <AhaSpinner
            size="lg"
            variant="tail"
          />
          <p class="mt-6 text-xs text-base-0">
            Just a moment please...
          </p>
        </div>
      </div>
    </AhaContent>

    <QuestionModeration v-else />

    <AhaFooter>
      <MainFooter v-if="presentation.id" />
    </AhaFooter>
  </AhaPage>
</template>

<script>
// components
import MainHeader from '@/components/main/MainHeader.vue'
import MainFooter from '@/components/main/MainFooter.vue'
import QuestionModeration from '@/components/question-moderation/QuestionModeration.vue'

// container
import MainFooterContainer from '@/containers/main/MainFooter.ts'

export default {
  components: {
    MainHeader,
    MainFooter: MainFooterContainer(MainFooter),
    QuestionModeration,
  },
  props: {
    isInAPresentation: {
      type: Boolean,
      default: false,
    },
    isLoadingPresentation: {
      type: Boolean,
      default: false,
    },
    presentation: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>

<style lang="scss">
#main-page {
  @apply bg-secondary-100;
}
</style>
